import { render, staticRenderFns } from "./account_xq.vue?vue&type=template&id=dea4daca&scoped=true&"
import script from "./account_xq.vue?vue&type=script&lang=js&"
export * from "./account_xq.vue?vue&type=script&lang=js&"
import style0 from "./account_xq.vue?vue&type=style&index=0&id=dea4daca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea4daca",
  null
  
)

export default component.exports